type DropdownItem = {
  value: string;
  label?: string;
};

/**
 * Extracts a single value from a Connect Components Dropdown onChange value array.
 */
export const extractDropdownValue = (value: DropdownItem[]): string => {
  const firstItem = value?.[0];
  if (typeof firstItem === 'string') return firstItem;
  if (firstItem && typeof firstItem === 'object') return firstItem.value ?? '';
  return '';
};

/**
 * Extracts multiple values from a Connect Components Dropdown onChange value array.
 */
export const extractDropdownValues = (value: DropdownItem[]): string[] => {
  const values: string[] = [];
  for (const item of value) {
    if (typeof item === 'string') values.push(item);
    else if (item?.value) values.push(item.value);
  }
  return values;
};
